import React, { useEffect, Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./i18n";

import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import ScrollManager from "./components/ScrollManager";

// Lazy-loaded pages
const Home = lazy(() => import("./pages/Home"));
const Capabilities = lazy(() => import("./pages/Capabilities"));
const Machinery = lazy(() => import("./pages/Machinery"));
const AboutContact = lazy(() => import("./pages/AboutContact"));
const NotFound = lazy(() => import("./pages/NotFound"));

export default function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <Router>
      {/* Handles route + hash scrolling */}
      <ScrollManager />

      <div className="min-h-screen flex flex-col">
        <Header />

        <main className="flex-1">
          <Suspense
            fallback={
              <div className="py-32 text-center text-muted-foreground">
                Loading…
              </div>
            }
          >
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/capabilities" element={<Capabilities />} />
              <Route path="/machinery" element={<Machinery />} />
              <Route path="/about" element={<AboutContact />} />

              {/* 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>

        <Footer />
        <WhatsAppButton className="h-10 w-10" />
      </div>
    </Router>
  );
}
